let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dIzxh")).then(() => parcelRequire('l3PcV'));